import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IOrderSearchResponse } from './IOrderSearchResponse';

export const getOrderDetails = (searchTerm: string, retailer: string): AxiosPromise<IOrderSearchResponse> => {
  return Fetch().then(axios => axios.get(
    `orders/details?retailer=${encodeURIComponent(retailer)}&order=${encodeURIComponent(searchTerm)}`,
  ));
};
